import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getSite } from '../tools/fetcher';

export default function ProductTitle({ products }) {
    const { isPending, isError, data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    const [currMsgIndex, setCurrMsgIndex] = useState(0);
    const [isFadingOut, setIsFadingOut] = useState(false);

    const messages = useMemo(
        () =>
            products
                .map((item) => item?.apartment_details?.address)
                .filter(
                    (address, index, self) => self.indexOf(address) === index,
                ),
        [products],
    );

    useEffect(() => {
        let unique = [];
        if (products.length) {
            unique = messages;
        }

        const interval = setInterval(() => {
            setIsFadingOut(true);

            setTimeout(() => {
                setCurrMsgIndex((prev) => (prev + 1) % unique.length);
                setIsFadingOut(false);
            }, 500);
        }, 5000);

        return () => clearInterval(interval);
    }, [products.length, messages, currMsgIndex]);

    if (isPending) {
        return <span>Loading...</span>;
    }
    if (isError) {
        return <span>Loading...</span>;
    }
    return (
        <p className="font-bold text-[24px] leading-[32px] sm:text-[40px] sm:leading-[48px]">
            {data?.product_banner?.title}{' '}
            <span
                className={classNames(
                    'text-apart-green-50',
                    messages.length >= 2 &&
                        `transition-all ${isFadingOut ? 'animate-[fadeOut_.5s_ease-in-out_forwards]' : 'animate-[fadeIn_.3s_ease-in-out_forwards]'}`,
                )}
            >
                {messages[currMsgIndex]}
            </span>
        </p>
    );
}
